(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-moderno"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciarFooter = () => {
      document.querySelectorAll('.sns-footer').forEach((footer) => {
        footer.querySelectorAll('.sns-footer-acordeon').forEach((boton) => {
          if (boton.dataset.iniciado === 'true') return;

          boton.dataset.iniciado = 'true';

          boton.addEventListener('click', () => {
            if (window.innerWidth >= 990) return;

            const columna = boton.closest('.sns-footer-columna-menu');
            const estaActivo = columna.classList.contains('is-active');

            columna.classList.toggle('is-active');
            boton.setAttribute('aria-expanded', estaActivo ? 'false' : 'true');
          });
        });
      });
    };

    document.addEventListener('DOMContentLoaded', iniciarFooter);
    document.addEventListener('shopify:section:load', iniciarFooter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    const menu = document.querySelector('.header__inline-menu');
    const hoverMenuEnabled = header && header.dataset.snsHoverMenu === 'true';

    if (!hoverMenuEnabled || !menu) return;

    const items = menu.querySelectorAll('details');

    items.forEach((item) => {
      const submenu = item.querySelector('ul');

      item.addEventListener('mouseenter', () => {
        item.setAttribute('open', true);
      });

      item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });

      if (submenu) {
        submenu.addEventListener('mouseleave', () => {
          item.removeAttribute('open');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-cyberday-contador"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciarContadorCyber = (seccion) => {
      if (!seccion || seccion.dataset.iniciado === 'true') return;

      const dias = seccion.querySelector('[data-days]');
      const horas = seccion.querySelector('[data-hours]');
      const minutos = seccion.querySelector('[data-minutes]');
      const segundos = seccion.querySelector('[data-seconds]');
      const estadoPrevio = seccion.querySelector('[data-estado-previo]');
      const estadoActivo = seccion.querySelector('[data-estado-activo]');

      if (!dias || !horas || !minutos || !segundos || !estadoPrevio || !estadoActivo) return;

      seccion.dataset.iniciado = 'true';

      const fechaInicio = new Date(seccion.dataset.fechaInicio).getTime();
      const redireccionActiva = seccion.dataset.redireccion === 'true';
      const redireccionUrl = seccion.dataset.redireccionUrl;

      if (Number.isNaN(fechaInicio)) return;

      const formatear = (valor) => {
        return valor < 10 ? `0${valor}` : `${valor}`;
      };

      const mostrarActivo = () => {
        estadoPrevio.hidden = true;
        estadoActivo.hidden = false;

        if (redireccionActiva && redireccionUrl) {
          window.location.href = redireccionUrl;
        }
      };

      const actualizar = () => {
        const ahora = new Date().getTime();
        const distancia = fechaInicio - ahora;

        if (distancia <= 0) {
          window.location.reload(true);
          return;
        }

        const diasRestantes = Math.floor(distancia / (1000 * 60 * 60 * 24));
        const horasRestantes = Math.floor((distancia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutosRestantes = Math.floor((distancia % (1000 * 60 * 60)) / (1000 * 60));
        const segundosRestantes = Math.floor((distancia % (1000 * 60)) / 1000);

        dias.textContent = formatear(diasRestantes);
        horas.textContent = formatear(horasRestantes);
        minutos.textContent = formatear(minutosRestantes);
        segundos.textContent = formatear(segundosRestantes);
      };

      actualizar();
      window.setInterval(actualizar, 1000);
    };

    const iniciarTodos = () => {
      document.querySelectorAll('.sns-cyber-contador').forEach(iniciarContadorCyber);
    };

    document.addEventListener('DOMContentLoaded', iniciarTodos);
    document.addEventListener('shopify:section:load', iniciarTodos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-landing-cyberday"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciarCyberday = (seccion) => {
      if (!seccion || seccion.dataset.iniciado === 'true') return;

      const dias = seccion.querySelector('[data-days]');
      const horas = seccion.querySelector('[data-hours]');
      const minutos = seccion.querySelector('[data-minutes]');
      const segundos = seccion.querySelector('[data-seconds]');

      if (!dias || !horas || !minutos || !segundos) return;

      seccion.dataset.iniciado = 'true';

      const fechaFinTexto = seccion.dataset.fechaFin;
      const fechaFin = new Date(fechaFinTexto).getTime();

      if (Number.isNaN(fechaFin)) return;

      const formatear = (valor) => {
        return valor < 10 ? `0${valor}` : `${valor}`;
      };

      const actualizar = () => {
        const ahora = new Date().getTime();
        let distancia = fechaFin - ahora;

        if (distancia < 0) {
          distancia = 0;
        }

        const diasRestantes = Math.floor(distancia / (1000 * 60 * 60 * 24));
        const horasRestantes = Math.floor((distancia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutosRestantes = Math.floor((distancia % (1000 * 60 * 60)) / (1000 * 60));
        const segundosRestantes = Math.floor((distancia % (1000 * 60)) / 1000);

        dias.textContent = formatear(diasRestantes);
        horas.textContent = formatear(horasRestantes);
        minutos.textContent = formatear(minutosRestantes);
        segundos.textContent = formatear(segundosRestantes);
      };

      actualizar();
      window.setInterval(actualizar, 1000);
    };

    const iniciarTodo = () => {
      document.querySelectorAll('.sns-cyberday').forEach(iniciarCyberday);
    };

    document.addEventListener('DOMContentLoaded', iniciarTodo);
    document.addEventListener('shopify:section:load', iniciarTodo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-oferta-relampago"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = section => {
      if (!section || section.dataset.started === 'true') return;
      const fields = ['days','hours','minutes','seconds'].map(key => section.querySelector(`[data-${key}]`));
      if (fields.some(field => !field)) return;
      section.dataset.started = 'true';
      let target;
      const getDailyTarget = () => {
        const now = new Date();
        const date = new Date();
        const hour = Number(section.dataset.resetHour || 24);
        if (hour >= 24) date.setHours(24,0,0,0);
        else if (now.getHours() < hour) date.setHours(hour,0,0,0);
        else { date.setDate(date.getDate() + 1); date.setHours(hour,0,0,0); }
        return date.getTime();
      };
      target = section.dataset.timerType === 'manual' ? new Date(section.dataset.endDate).getTime() : getDailyTarget();
      if (Number.isNaN(target)) target = getDailyTarget();
      const tick = () => {
        let distance = Math.max(0, target - Date.now());
        if (distance === 0 && section.dataset.timerType !== 'manual') { target = getDailyTarget(); distance = target - Date.now(); }
        const values = [Math.floor(distance / 86400000), Math.floor(distance % 86400000 / 3600000), Math.floor(distance % 3600000 / 60000), Math.floor(distance % 60000 / 1000)];
        fields.forEach((field,index) => { field.textContent = String(values[index]).padStart(2,'0'); });
      };
      tick();
      window.setInterval(tick,1000);
    };
    const init = root => root.querySelectorAll('.sns-flash').forEach(start);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document)); else init(document);
    document.addEventListener('shopify:section:load',event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
